module.exports = __webpack_public_path__ + "img/offline-heading.50863e0b.svg";